// This is the one place we allow this.
// eslint-disable-next-line no-restricted-imports
import { Portal as ChakraPortal, useModalContext } from '@chakra-ui/react';

/**
 * A Portal component that is Modal-aware. If rendered within a Modal, it will
 * render its children into the Modal's dialog element instead of the body.
 * This is to ensure that any popovers or tooltips rendered within a Modal are
 * properly contained within the Modal and not affected by any overflow:hidden
 * styles on parent elements.
 *
 * @remarks
 *
 * @see {@link https://github.com/chakra-ui/chakra-ui/issues/6794}
 */
export function Portal({ children }: { children: React.ReactNode }) {
  try {
    const modalContext = useModalContext();
    return (
      <ChakraPortal containerRef={modalContext?.dialogRef}>
        {children}
      </ChakraPortal>
    );
  } catch {
    return <ChakraPortal>{children}</ChakraPortal>;
  }
}
